import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { QRCodeCanvas } from 'qrcode.react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDonateOpen, setIsDonateOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView();
    setIsMenuOpen(false);
  };

  const upiId = "stalphonsacharitabletrust@sbi";
  const name = "St.Alphonsa Charitable Trust";
  const upiLink = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(name)}&cu=INR`;

  return (
    <>
      {/* Navbar */}
      <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md border-b border-white/20 shadow">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            
            {/* Logo */}
            <div className="flex items-center gap-2">
              <img src="/logo512.png" alt="Logo" className="h-24 w-24" />
              <span className="text-lg md:text-2xl font-bold text-blue-900">
                St.Alphonsa Charitable Trust
              </span>
            </div>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-8">
              {['home', 'about', 'services', 'gallery', 'contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className="font-medium text-blue-900 hover:text-blue-600 transition"
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </button>
              ))}
              <button
                onClick={() => setIsDonateOpen(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
              >
                Donate
              </button>
            </div>

            {/* Mobile Toggle */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden text-blue-900"
            >
              {isMenuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
            </button>
          </div>
        </div>

        {/* ✅ MOBILE DROPDOWN MENU */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 flex justify-center px-4">
            <div
              className="
                mt-4 w-full max-w-md
                rounded-2xl bg-white/90 backdrop-blur-xl
                border border-white/40 shadow-xl
                animate-[fadeSlide_0.25s_ease-out]
              "
            >
              <div className="p-6 space-y-5">
                {[
                  { label: 'Home', id: 'home' },
                  { label: 'About Us', id: 'about' },
                  { label: 'Services', id: 'services' },
                  { label:'Gallery', id:'gallery' },
                  { label: 'Contact', id: 'contact' }
                ].map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="
                      w-full text-left
                      text-base font-medium text-blue-900
                      hover:text-blue-600 transition
                    "
                  >
                    {item.label}
                  </button>
                ))}

                {/* Divider */}
                <div className="h-px bg-blue-100" />

                {/* Donate CTA */}
                <button
                  onClick={() => {
                    setIsDonateOpen(true);
                    setIsMenuOpen(false);
                  }}
                  className="
                    w-full py-3 rounded-xl
                    bg-blue-600 text-white
                    font-semibold text-base
                    shadow hover:bg-blue-700
                    transition
                  "
                >
                  Donate Now
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Donate Modal */}
      {isDonateOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md relative">
            <button
              onClick={() => setIsDonateOpen(false)}
              className="absolute top-4 right-4"
            >
              <X className="h-6 w-6 text-gray-600" />
            </button>

            <h2 className="text-2xl font-bold text-center text-blue-900 mb-4">
              Donate to {name}
            </h2>

            <div className="flex flex-col items-center gap-4">
              <QRCodeCanvas value={upiLink} size={180} />
              <p className="text-gray-700 text-center">
                UPI ID: <strong>{upiId}</strong>
              </p>
              <p className="text-gray-700">Bank: State Bank of India</p>
                <p className="text-gray-700">Account No: 43838295265</p>
                <p className="text-gray-700">IFSC: SBIN0006456</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
